// extracted by css-extract-rspack-plugin
export default {"ContactSupport":"ContactSupport-module__ContactSupport___QkeNe","contactSupport":"ContactSupport-module__ContactSupport___QkeNe"};